import FilesSideDrawer from './FilesSideDrawer'

export default FilesSideDrawer
